import routes from "./";
import { matchPath } from "react-router-dom";

const matchRoutes = ({ pathname, exact = false }) =>
  routes.find(({ props: { path } }) => matchPath(pathname, { path, exact }));

export default matchRoutes;
